var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13164_7478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.4998C10.4233 22.4998 8.39323 21.8839 6.66652 20.7302C4.9398 19.5764 3.59399 17.9366 2.79927 16.0179C2.00455 14.0993 1.79661 11.9881 2.20176 9.95131C2.6069 7.91451 3.60693 6.04359 5.07538 4.57514C6.54384 3.10669 8.41476 2.10666 10.4516 1.70152C12.4884 1.29637 14.5996 1.50431 16.5182 2.29903C18.4368 3.09375 20.0767 4.43956 21.2304 6.16627C22.3842 7.89299 23 9.92306 23 11.9998C22.9968 14.7836 21.8896 17.4524 19.9211 19.4209C17.9527 21.3893 15.2838 22.4966 12.5 22.4998ZM12.5 4.49976C11.0166 4.49976 9.5666 4.93963 8.33323 5.76374C7.09986 6.58785 6.13857 7.75919 5.57091 9.12964C5.00325 10.5001 4.85473 12.0081 5.14412 13.4629C5.4335 14.9178 6.14781 16.2542 7.1967 17.3031C8.2456 18.352 9.58197 19.0663 11.0368 19.3557C12.4917 19.645 13.9997 19.4965 15.3701 18.9289C16.7406 18.3612 17.9119 17.3999 18.736 16.1665C19.5601 14.9332 20 13.4831 20 11.9998C19.9976 10.0114 19.2067 8.1051 17.8007 6.69909C16.3947 5.29308 14.4884 4.50214 12.5 4.49976Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00017 23.9999C1.70354 23.9998 1.4136 23.9118 1.16698 23.747C0.920366 23.5822 0.728157 23.3479 0.614652 23.0739C0.501147 22.7998 0.471442 22.4983 0.529294 22.2073C0.587145 21.9164 0.729955 21.6492 0.939669 21.4394L21.9397 0.439378C22.2226 0.166141 22.6015 0.0149496 22.9948 0.0183673C23.3881 0.0217849 23.7643 0.179538 24.0424 0.457651C24.3205 0.735763 24.4783 1.11198 24.4817 1.50528C24.4851 1.89857 24.3339 2.27748 24.0607 2.56038L3.06067 23.5604C2.77943 23.8417 2.39796 23.9998 2.00017 23.9999Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13164_7478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEntry);
export default __webpack_public_path__ + "static/media/noEntry.ad0fbd95c4840bb2b3ce13e6a0b35161.svg";
export { ForwardRef as ReactComponent };